export enum OpportunityType {
  IRONPLANET = 'IronPlanet Opportunity',
  MULTICHANNEL = 'Multi-Channel Opportunity',
  ANNUAL = 'Annual/ Key/ Strategic',
  EXHIBIT_A = 'Exhibit A Opportunity',
  FIXED_ASSETS = 'Fixed Assets',
  SUSPENSE_ASSETS = 'Suspense Assets',
  INVENTORY_ASSETS = 'Inventory Assets',
  NON_MARS = 'Non-MARS Opportunity',
  CONSIGNMENT_OPPORTUNITY = 'Consignment Opportunity',
  CONFIDENTIAL = 'Confidential'
}
